'use client';

import { Pause, Volume2 } from 'lucide-react';
import { type JSX, useRef, useState } from 'react';

interface IPronunciationButtonProps {
  audioUrl: string | null;
  label: string;
}

export function PronunciationButton({
  audioUrl,
  label,
}: IPronunciationButtonProps): JSX.Element | null {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  if (!audioUrl) {
    return null;
  }

  const handleClick = (): void => {
    const el = audioRef.current;
    if (!el) {
      return;
    }
    if (!el.paused) {
      el.pause();
      el.currentTime = 0;
      return;
    }
    el.play();
  };

  return (
    <>
      <button
        aria-label={label}
        className="inline-flex size-7 items-center justify-center rounded-full text-muted-foreground transition hover:bg-foreground/10 hover:text-foreground"
        onClick={handleClick}
        type="button"
      >
        {isPlaying ? (
          <Pause aria-hidden="true" className="size-4" />
        ) : (
          <Volume2 aria-hidden="true" className="size-4" />
        )}
      </button>
      <audio
        onEnded={(): void => setIsPlaying(false)}
        onPause={(): void => setIsPlaying(false)}
        onPlay={(): void => setIsPlaying(true)}
        preload="none"
        ref={audioRef}
        src={audioUrl}
      >
        <track kind="captions" />
      </audio>
    </>
  );
}
